<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Open Client Credits Report</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12">
        <div class="p-wrapper-custom">
          <p-table
            #dt
            responsiveLayout="scroll"
            [value]="openClientCreditsResponseFilteredList"
            styleClass="p-datatable-customers"
            [rowHover]="true"
            [rows]="50"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 20, 50, 1000]"
            [autoLayout]="true"
            [resizableColumns]="true"
            [paginator]="openClientCreditsResponseFilteredList.length >= 50"
            (onFilter)="onFilter($event)"
            stripedRows
            [rowHover]="true"
            [showCurrentPageReport]="true"
            scrollHeight="calc(100vh - 310px)"
            [size]="'small'"
            [paginator]="true"
            paginatorStyleClass="paginator-table"
            styleClass="table-listing">
            <ng-template pTemplate="header">
              <tr class="table-head">
                <th pSortableColumn="invoiceDate">
                  Invoice Date <p-sortIcon field="invoiceDate"></p-sortIcon>
                </th>
                <th>Invoice Number</th>
                <th>Sales Order#</th>
                <th>Project Name</th>
                <th>Customer Number</th>
                <th>Customer Name</th>
                <th>Amount not settled $</th>
                <th
                  [ngClass]="{ trimmedby50char: descriptionCharacterCond }"
                  class="jname text-center">
                  Note
                </th>
              </tr>
              <tr>
                <th>
                  <jni-date-filter
                    [dataList]="openClientCreditsResponseLists"
                    [filteredDataList]="openClientCreditsResponseFilteredList"
                    [columnName]="dateColumn"
                    (emitCancelFilter)="clearFilter($event)"
                    (emitApplyFilter)="applyFilter($event)">
                  </jni-date-filter>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="invoice"
                      id="invoice"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'invoice',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="salesOrderId"
                      id="salesOrderId"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'salesOrderId',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th></th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="customerAccount"
                      id="customerAccount"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'customerAccount',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th>
                  <div class="d-flex">
                    <input
                      jniAutoCompleteBlocker
                      pInputText
                      type="text"
                      name="customerName"
                      id="customerName"
                      style="max-width: 200px"
                      (input)="
                        dt.filter(
                          $any($event.target).value,
                          'customerName',
                          'contains'
                        )
                      "
                      placeholder=""
                      class="p-column-filter p-inputtext p-component" />
                  </div>
                </th>
                <th></th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-openClientCreditsDetailLists
              let-rowIndex="rowIndex">
              <tr class="p-selectable-row">
                <td>
                  {{
                    openClientCreditsDetailLists.invoiceDate
                      | date: "MM-dd-yyyy"
                  }}
                </td>

                <td>
                  <a
                    class="link"
                    (click)="
                      getInvoiceReport(openClientCreditsDetailLists.invoice)
                    ">
                    {{ openClientCreditsDetailLists.invoice }}
                  </a>
                </td>
                <td>
                  <a
                    class="link"
                    (click)="
                      redirectToSaleorder(
                        openClientCreditsDetailLists.salesOrderId
                      )
                    ">
                    {{ openClientCreditsDetailLists.salesOrderId }}
                  </a>
                </td>
                <td>{{ openClientCreditsDetailLists.projectName }}</td>
                <td>
                  <a
                    class="link"
                    (click)="
                      redirectToClient(
                        openClientCreditsDetailLists.customerAccount
                      )
                    ">
                    {{ openClientCreditsDetailLists.customerAccount }}
                  </a>
                </td>
                <td>{{ openClientCreditsDetailLists.customerName }}</td>
                <td class="name">
                  {{
                    openClientCreditsDetailLists.amountNotSettled
                      | currency: "USD" : "symbol" : "0.2-2"
                  }}
                </td>
                <td
                  [ngClass]="{
                    'trimmeddescription trimmedby50char':
                      descriptionCharacterCond,
                  }"
                  class="name">
                  {{
                    descriptionCharacterCount(
                      openClientCreditsDetailLists.note
                    )
                  }}{{ openClientCreditsDetailLists.note }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="30">No Data Found.</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="footer">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="align-right">
                  {{ totalAmountNotSettled | currency: "USD" }}
                </td>
                <td></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      [isModal]="true"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
